import React from 'react';
import { Empty, Table, Typography } from 'antd';
import ReportSection from './components/ReportSection';
import { renderBoolTag } from './trans.effect';
import { toRrzuVideoViewModel } from './struct';

interface Props {
  data: any;
}

const RrzuVideoTab: React.FC<Props> = ({ data }) => {
  if (!data) return <Empty description="暂无数据" />;

  const vm = toRrzuVideoViewModel(data);
  if (!vm) return <Empty description="数据解析失败" />;

  const boolKeys = new Set(['is_id', 'is_name', 'has_guidance_detected', 'has_multshows_tensioniple_subjects']);
  const rows = vm.rows.map((r) => ({
    ...r,
    value: boolKeys.has(r.key) ? renderBoolTag(r.value, { truthyColor: 'green', falsyColor: 'red' }) : r.value,
  }));

  return (
    <div style={{ padding: 20, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial' }}>
      <>
        <ReportSection title="风控结果" extra={<span>订单号: {vm.orderId || '-'}</span>} bodyStyle={{ padding: 24 }}>
          <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
            {vm.shipText ? (
              <span style={{ fontSize: 24, fontWeight: 'bold', color: vm.shipColor }}>{vm.shipText}</span>
            ) : (
              <span style={{ fontSize: 24, fontWeight: 'bold', color: '#d9d9d9' }}>未定性</span>
            )}
          </div>

          {vm.cause ? (
            <div style={{ marginBottom: 16 }}>
              <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>{vm.cause}</Typography.Paragraph>
            </div>
          ) : null}

          <Table
            dataSource={rows}
            columns={[
              { title: '关键指标', dataIndex: 'label', key: 'label', width: 250, onHeaderCell: () => ({ style: { fontWeight: 400 } }) },
              { title: '详情', dataIndex: 'value', key: 'value' },
            ]}
            pagination={false}
            bordered
            rowKey="key"
            size="small"
          />
        </ReportSection>
      </>
    </div>
  );
};

export default RrzuVideoTab;
